import React from "react";
import { Link } from 'react-router-dom'
import PropTypes from "prop-types";
import "../css/Project.css";
import Slideshow from "./Slideshow";
import SlideshowMix from "./SlideshowMix";

/**
 * Project component
 */
class Project extends React.Component {
  static displayName = "Project";
  static propTypes = {
    className: PropTypes.string,
    project: PropTypes.object
  };
  static defaultProps = {};

  /**
   * @constructor
   * @param {Object} props
   */
  constructor(props) {
    super(props);
    this.className = "Project";
  }

  getProjectLink(project){
    if(project.linked_project || project.external_link){

      if(project.is_external){
        return <a
            className={`${this.className}__linked`}
            href={project.external_link}
            target="_blank"
        >
          Voir le projet
        </a>
      }
      else{
        return <Link
            className={`${this.className}__linked`}
            to={project.linked_project}
        >
          Voir le projet 
        </Link>
      }
    }
      
  }
  /**
   * @override
   */
  render() {
    return (
      <div className={`${this.className} ${this.props.className || ""}`}>
        <div className={`${this.className}__container`}>
          <div className={`${this.className}__slideshows`}>
            {this.props.project.slideshow_photo && (
              <div className={`${this.className}__photos`}>
                <Slideshow
                  images={this.props.project.slideshow_photo}
                  {...this.props}
                />
              </div>
            )}
            {this.props.project.slideshow_plan && (
              <div className={`${this.className}__maps`}>
                <Slideshow
                  images={this.props.project.slideshow_plan}
                  {...this.props}
                />
              </div>
            )}
            {this.props.project.slideshows && (
              <div className={`${this.className}__slideshowmix ${this.className}__photos`}>
                {this.props.project.slideshows.map((slideshow, index) => (
                  <div className={`${this.className}__maps`} key={'slideshowMix'+index}>
                      <SlideshowMix
                        images={this.props.project.slideshow_photo}
                        slideshow={slideshow}
                        {...this.props}
                      />
                  </div>
                ))}
              </div>
            )}
          </div>
          <div className={`${this.className}__text`}>
            <p>
              {this.props.project.title}
              <br />
              {this.props.project.year.join("–")}
            </p>
            {this.props.project.description_actu !== "" && (
                <div
                  style={{ marginTop: "1.25rem" }}
                  dangerouslySetInnerHTML={{
                    __html: this.props.project.description_actu_html
                  }}
                />
              )}
            {this.props.project.master && (
              <p>
                Maître d'ouvrage
                <br />
                {this.props.project.master}
              </p>
            )}
            {this.props.project.partenaires.length > 0 && (
              <p>
                Mandataires
                <br />
                {this.props.project.partenaires.map((partenaire, index) => (
                  <div key={index}>{partenaire}</div>
                ))}
              </p>
            )}
            {this.props.project.numbers.length > 0 && (
              <p>
                Chiffres
                <br />
                {this.props.project.numbers.map((number, index) => (
                  <div key={index}>{number}</div>
                ))}
              </p>
            )}
            {this.props.project.collaborators.length > 0 && (
              <p>
                Collaboratrices et collaborateurs
                <br />
                {this.props.project.collaborators.join(", ")}
              </p>
            )}
            {this.props.project.type && (
              <p>
                Procédure
                <br />
                {this.props.project.type}
              </p>
            )}
            {this.props.project.credits_photo.length > 0 && (
              <p>
                Crédit photos
                <br />
                {this.props.project.credits_photo.map((credit, index) => (
                  <span key={index}>{credit}</span>
                ))}
              </p>
            )}


            {this.getProjectLink(this.props.project)}
          </div>
        </div>
      </div>
    );
  }
}

export default Project;
